import React, { useEffect, useRef, useState } from 'react';
import styles from './SlideOne.module.scss';
import Text from '../../../../../atoms/text/Text';
import MajorCard from '../../../../../molecule/bachelorCard/MajorCard';
const employee = '/icons/employee.svg';
import ScrollReveal from 'scrollreveal';
import { useSelector } from 'react-redux';
import useIsRtl from '../../../../../../app/helpers/isRtl';
import getCookie from '../../../../../../app/helpers/getCookie';
import { useNavigate } from 'react-router-dom';

const DEGREE_TYPE = {
  bachelors: 0,
  masters: 1,
  phd: 2,
};

const SlideOne = () => {
  const navigate = useNavigate();
  const isRtl = useIsRtl();

  const [activeTab, setActiveTab] = useState('bachelors');

  const isEnglish = !!getCookie('googtrans')?.includes('/ar/en');

  const titleRef = useRef(null);
  const boxRef = useRef(null);

  useEffect(() => {
    if (titleRef.current) {
      ScrollReveal().reveal(titleRef.current, {
        delay: 100,
        duration: 500,
        easing: 'ease-in-out',
        opacity: 0,
        scale: 0.9,
        distance: '20px',
        reset: true,
      });
    }

    if (boxRef.current) {
      ScrollReveal().reveal(boxRef.current.children, {
        delay: 500,
        duration: 500,
        easing: 'ease-in-out',
        opacity: 0,
        scale: 0.9,
        distance: '20px',
        reset: true,
        interval: 200,
      });
    }
  }, []);

  const barData = [
    { title: 'navigationMenu.bachelors2', key: 'bachelors' },
    { title: 'navigationMenu.masters2', key: 'masters' },
    { title: 'navigationMenu.phd2', key: 'phd' },
  ];

  const degreeData = useSelector((s) => s?.degreeData?.degreeData);
  const items = degreeData?.items ?? [];

  const displayedDegrees = React.useMemo(() => {
    const type = DEGREE_TYPE[activeTab];
    if (type == null) return [];
    return items.filter((it) => it?.degreeType === type).slice(0, 8);
  }, [items, activeTab]);
  return (
    <div className={styles['slide']}>
      <div ref={titleRef} className={styles['content']}>
        <Text
          title="home.Programs"
          variant="text-bold-italic-30"
          style={{ textTransform: 'uppercase' }}
          textContainerStyle={{ textAlign: 'center' }}
        />

        <div className={`${styles.tabs} ${isRtl ? 'rtl' : ''}`}>
          {barData.map((tab) => (
            <div
              key={tab.key}
              className={`${styles.tab} ${activeTab === tab.key ? styles.active : ''}`}
              onClick={() => setActiveTab(tab.key)}
            >
              <Text
                title={
                  isEnglish && tab.key === 'bachelors'
                    ? 'Bachelor’s'
                    : tab.title
                }
                variant="text-regular-20"
                className={styles['tab-text']}
                color={activeTab === tab.key ? '#008755' : '#757574'}
              />
            </div>
          ))}
        </div>

        <div className={styles['grid-container']}>
          <div
            ref={boxRef}
            className={styles['grid']}
            style={{ direction: isRtl ? 'rtl' : 'ltr' }}
          >
            {displayedDegrees.slice(0, 8).map((item) => {
              if (!item?.degreeNameAr) return null;

              let displayTitle = item.degreeNameAr;
              if (isEnglish) {
                displayTitle = item.degreeNameAr.includes('بكالوريوس')
                  ? `Bachelor's ${item.degreeNameAr.replace('بكالوريوس', '')}`.trim()
                  : item.degreeNameAr;
              }

              return (
                <MajorCard
                  key={item.degreeId}
                  id={item.degreeId}
                  titleEN={displayTitle}
                  title={displayTitle}
                  className={styles.card}
                  isCadet={item.forAllOrCadets}
                  svg={employee}
                />
              );
            })}
          </div>
        </div>
      </div>{' '}
      <div className={styles['view-container']}>
        <button
          className={styles['view-btn']}
          onClick={() =>
            navigate('/degree-programs', {
              state: {
                type:
                  activeTab === 'phd'
                    ? 4
                    : activeTab === 'masters'
                      ? 3
                      : activeTab === 'bachelors'
                        ? 2
                        : 1,
              },
            })
          }
        >
          <Text
            title="common.view_all"
            variant="text-bold-italic-16"
            maxLines={2}
            className={styles.btnTitle}
          />
        </button>
      </div>
    </div>
  );
};

export default SlideOne;
